function TodoLoading(params) {
    return <h2>Loading data...</h2>
}

export { TodoLoading }
